<div class="row row-replace">
    <div class="col-4 col-pn">
        <div class="form-inline">
            <label for="itemperpage">Items Per Page</label>
            <select name="itemperpage" id="itemperpage" class="form-control ml-10" (change)="getNumberPerPage($event)">
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="30">30</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
        </div>
    </div>
</div>
<div class="table-responsive">
    <table class="table table-row-fixed">
        <thead>
            <tr class="bg-primary text-white">
                <th>Query Id</th>
                <!-- <th>Action</th> -->
                <th>Employee Details</th>
                <!-- <th>Category</th> -->
                <th>Sub Category</th>
                <th>Source</th>
                <th>Log Date</th>
                <th>Resolve Date</th>
                <th>Site Name</th>
                <th>Assigned To</th>
                <th>Created By</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="
        let item of myQueryData
          | paginate
            : {
                id: 'myqrypage',
                itemsPerPage: pageSize,
                currentPage: page,
                totalItems: count
              }
      ">
                <td>
                    {{ item.qry_id }}
                    <p>{{ item.stage_desc }}</p>
                    <!-- <button *ngIf="item.stage_id == 4" class="btn btn-sm btn-warning" (click)="openReOpenModal(item)"
            type="button">
            Re-open
          </button> -->
                </td>
                <!-- <td (click)="editQuery(item)"><i class="fa fa-eye"></i></td> -->
                <td>{{ item.username }} - {{ item.name }}</td>
                <!-- <td>{{ item.cat_desc }}</td> -->
                <td>{{ item.subcat1_desc }}</td>
                <td>{{ item.source }}</td>
                <td>
                    <span *ngIf="item.log_date != '0000-00-00 00:00:00'">{{
            item.log_date | date: "d-LLL-y"
            }}</span>
                </td>
                <td>
                    <span *ngIf="item.rslv_date != '0000-00-00 00:00:00'">{{
            item.rslv_date | date: "d-LLL-y"
            }}</span>
                </td>
                <td>{{ item.cc_desc }}</td>
                <td>
                    <ul>
                        <li *ngFor="let data of item.assigned">
                            {{ data.username }} - {{ data.fullname }}
                        </li>
                    </ul>
                </td>
                <td>{{ item.created_name }}</td>
                <!-- <td>
                              <p>{{item.stage_desc}}</p>
                            </td>
                            -->
            </tr>
        </tbody>
    </table>
    <div class="row row-replace">
        <div class="col-12 col-pn">
            <div class="card-table flex-fill">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <label>Showing {{ from }} - {{ to }} of {{ count }}</label>
                        </div>
                        <div class="col">
                            <label class="float-right">
                <pagination-controls previousLabel="Prev" nextLabel="Next" responsive="true"
                  (pageChange)="handlePageChange($event)" id="myqrypage"></pagination-controls>
              </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="query_report_modal" class="modal custom-modal fade" data-backdrop="static" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="zero_country_form_title">Query Master</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModals()">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <!-- <form  (ngSubmit)="()"> -->
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Query Type</label>
                            <select class="form-control" [(ngModel)]="filterQuery.queryType">
                <option value="">All</option>
                <option value="non_ivr">Non IVR</option>
                <option value="ivr">IVR</option>
              </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success btn-sm" (click)="onSubmitFormQuery()">
          Get Excel
        </button>
                <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" (click)="closeModals()">
          Close
        </button>
            </div>
            <!-- </form> -->
        </div>
    </div>
</div>